<template>
  <header class="container-fluid">
    <slot></slot>
    <video preload="auto" autoplay="true" loop="true" muted="true">
      <source
        src="/movie.mp4"
        type="video/mp4"
      />
    </video>
  </header>
</template>

<style scoped>
header {
  height: 900px;
  /* max-height: 752px; */
  /* background-image: url("/img/header_main_plash.png"); */
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: flex-start;
  align-content: space-between;
  padding-top: 30px;
  /* z-index: 2; */
  position: relative;
}
video {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>

<style scoped>
@media (max-width: 1200px) {
  header {
    height: 100vh !important;
    max-height: 100vh !important;
    padding: 0 !important;
  }
}
</style>
